import { MenuUnfoldOutlined, MenuFoldOutlined, LogoutOutlined } from '@ant-design/icons'
import { createFromIconfontCN } from '@ant-design/icons'
import { Layout, Menu, Popconfirm } from 'antd'
import React, { useState } from 'react'
import './index.scss'
import { Outlet, Link, useLocation, useNavigate } from 'react-router-dom'

import { BreadcrumbName } from '@/components'


//mobx
import { useStore } from '@/store'
import { observer } from 'mobx-react-lite'
import { toJS } from 'mobx'


const LayoutPage = () => {
  const { Header, Sider, Content, Footer } = Layout

  const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/c/font_4156506_u53m1rlecuq.js',
  })

  const getItem = (label, key, icon, children) => {
    return {
      label, key, icon, children
    }
  }
  //mobx
  const { LoginStore } = useStore()

  //路由高亮
  let { pathname } = useLocation()

  const [collapsed, setCollapsed] = useState(false)

  //退出按钮
  const navigate = useNavigate()
  const onLogout = () => {
    LoginStore.loginOut()
    navigate('/login')
  }

  //定义方法:菜单无限级递归
  const menuList = toJS(LoginStore.menuList)
  let openKeys = ''
  const breadcrumbItems = []
  const tree = (data) => {
    return data.map((item) => {
      if (pathname === `/${item.path}`) {
        if (item.pid === 0) {
          breadcrumbItems.push({
            'id': item.id,
            'name': item.name
          })
        } else {
          const father = menuList.filter(listItem => listItem.id === item.pid)
          breadcrumbItems.push({
            'id': father[0].id,
            'name': father[0].name
          })
          breadcrumbItems.push({
            'id': item.id,
            'name': item.name
          })
        }
        openKeys = '' + item.pid
      }
      if (item.hasOwnProperty('children') === false) {
        return getItem(
          <Link to={item.path}>
            {item.name}
          </Link>,
          `/${item.path}`,
          <IconFont type={item.icon || ' '} />,
          null
        )
      } else {
        return getItem(
          item.name,
          item.id,
          <IconFont type={item.icon || ''} />,
          tree(item.children)
        )
      }
    })
  }
  const newList = tree(menuList)
  return (
    <Layout>
      <Header>
        <div className='headerBox'>
          <div className="logo">
            大田种植物联网监测应用云服务
            {React.createElement(collapsed ? MenuUnfoldOutlined : MenuFoldOutlined, {
              className: 'trigger',
              onClick: () => setCollapsed(!collapsed),
            })}
          </div>
          <div className='sign_out'>
            <span className='userName'>{LoginStore.userName}</span>
            <span className="user-logout">
              <Popconfirm title="是否确认退出？" okText="退出" cancelText="取消" onConfirm={onLogout}>
                <LogoutOutlined /> 退出
              </Popconfirm>
            </span>
          </div>
        </div>
      </Header>
      <Layout>
        <Sider width={240} className="site-layout-background" trigger={null} collapsible collapsed={collapsed}>
          <Menu theme="dark" selectedKeys={[pathname]} defaultSelectedKeys={[openKeys]} defaultOpenKeys={[openKeys]} mode="inline" items={newList} style={{ background: "#161921" }} />
        </Sider>
        <Layout>
          <BreadcrumbName breadcrumbItems={breadcrumbItems}></BreadcrumbName>
          <Content style={{
            margin: '0 20px 20px 20px',
            background: "#282c34",
            padding: '20px',
            height: "100%",
            overflow: "auto"
          }}>
            <Outlet />
          </Content>
          <Footer>
            <div className="footer">
              <div className="bottom">  技术支持：吉林省农业综合信息服务股份有限公司
                {/* 备案号：吉ICP备10004098号-93
                <a style={{ color: '#ffffff', marginLeft: '5px' }} href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=22017202000395">
                  <img src="https://kaili-html.oss-cn-qingdao.aliyuncs.com/public/yucommon/gaba.png" />
                  吉公网安备22017202000395号
                </a> */}
              </div>
            </div>
          </Footer>
        </Layout>
      </Layout>
    </Layout>

  )
}

export default observer(LayoutPage)